import React, { Component } from "react";
import { Col, Card, Form, Button, Row, InputNumber, Modal } from "antd";
import _ from "lodash";
import { backFormatRupiah } from "../../../../Utils";
const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 8 },
    md: { span: 10 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 16 },
    md: { span: 14 },
  },
};
class DealSection extends Component {
  state = {
    sisaRuangNego: 0,
    hargaFinal: null,
    defaultFinalPriceApproval: 0,
    bonusKacab: 0,
    bonusBOH: 0,
    salesman: 0,
    supervisor: 0,
    totalBenefitTiFinal: 0,
    modalConfirm: false,
    modalConfirmDetail: false,
  };

  componentDidMount() {
    let { isTrust } = this.props;
    if (isTrust) {
      this.calculationNego(null, this.props.calculation);
      this.getFinalPriceApproval(this.props.calculation);
    } else {
      this.calculationMobbi(null, this.props.calculation);
    }
  }

  getFinalPriceApproval(calculation) {
    let data;
    const finalPrice = _.find(calculation, { name: "Harga Final Approval" });
    if (finalPrice) {
      const { calculation } = this.props;
      const ruangNego = _.find(calculation, { name: "Ruang Nego" });
      if (ruangNego && ruangNego.price !== "N/A") {
        const hargaPenawaran = _.find(calculation, { name: "Harga Penawaran" });
        data = this.calculationPrice(
          ruangNego.price,
          hargaPenawaran.price,
          finalPrice.price
        );
      }
      this.setState({
        ...data,
        defaultFinalPriceApproval: finalPrice.price,
      });
    }
  }

  getHargaFinal(calculation) {
    let totalBenefitTiFinal = 0;

    //Koreksi MRP
    const koreksiMrp = _.find(calculation, { name: "Koreksi MRP" });
    if (koreksiMrp) {
      totalBenefitTiFinal = koreksiMrp.price || 0;
    } else {
      // Harga Final Appraisal
      const hargaFinalAppraisal = _.find(calculation, {
        name: "Harga Final",
      });
      if (hargaFinalAppraisal) {
        totalBenefitTiFinal = hargaFinalAppraisal.price || 0;
      }
    }

    return totalBenefitTiFinal;
  }

  calculationNego(price, calculation) {
    let ruangNego = _.find(calculation, { name: "Ruang Nego" });
    let totalBenefit = _.find(calculation, { name: "Total Benefit TI" });

    if (this.props.approvalType === "Trade In") {
      this.props.changeFinalPrice(price);
    }

    if (ruangNego && ruangNego.price !== "N/A") {
      if (price) {
        //Koreksi MRP or Harga Final Appraisal
        let hargaFinal = this.getHargaFinal(calculation);
        let hargaPenawaran = _.find(calculation, { name: "Harga Penawaran" });
        let totalBenefitTiFinal = 0;
        const data = this.calculationPrice(
          ruangNego.price,
          hargaPenawaran.price,
          price
        );

        // Check Total Benefit Final
        if (totalBenefit && totalBenefit.price !== "N/A") {
          //Total Benefit Final = Harga Final - Input User + Total Benefit
          totalBenefitTiFinal = hargaFinal - price + totalBenefit.price || 0;
        } else {
          totalBenefitTiFinal = totalBenefit.price || "N/A";
        }

        this.setState({
          ...data,
          hargaFinal: price,
          totalBenefitTiFinal,
        });
      } else {
        // Jika tidak ada input user, get data Total Benefit TI (Final)
        let totalBenefitFinal = _.find(calculation, {
          name: "Total Benefit TI (Final)",
        });
        if (totalBenefitFinal && totalBenefitFinal.price) {
          this.calculationCommission(totalBenefitFinal);
        } else {
          // Jika tidak ada Benefit TI Final, menggunakan Benefit TI
          this.calculationCommission(totalBenefit);
        }
      }
    } else {
      this.setState({ hargaFinal: price });
    }
  }

  calculationMobbi(price, calculation) {
    let totalBenefit = _.find(calculation, { name: "Total Benefit TI" });

    if (this.props.approvalType === "Trade In") {
      this.props.changeFinalPrice(price);
    }

    if (price) {
      //Koreksi MRP or Harga Final Appraisal
      let hargaFinal = this.getHargaFinal(calculation);
      let hargaPenawaran = _.find(calculation, { name: "Harga Penawaran" });
      let totalBenefitTiFinal = 0;

      // Check Total Benefit Final
      if (totalBenefit && totalBenefit.price !== "N/A") {
        //Total Benefit Final = Harga Final - Input User + Total Benefit
        totalBenefitTiFinal = hargaFinal - price + totalBenefit.price || 0;
      } else {
        totalBenefitTiFinal = totalBenefit.price || "N/A";
      }

      this.setState({
        hargaFinal: price,
        totalBenefitTiFinal,
      });
    } else {
      // Jika tidak ada input user, get data Total Benefit TI (Final)
      let totalBenefitFinal = _.find(calculation, {
        name: "Total Benefit TI (Final)",
      });
      this.setState({
        totalBenefitTiFinal: totalBenefitFinal
          ? totalBenefitFinal.price
          : (totalBenefit && totalBenefit.price) || 0,
      });
    }
  }

  calculationCommission(totalBenefit) {
    const { commission } = this.props;
    if (commission && commission.length > 0) {
      let sisaRuangNego = _.find(commission, { name: "Sisa Ruang Nego" });
      let bonusKacab = _.find(commission, { name: "Kacab AUTO2000" });
      let bonusBOH = _.find(commission, { name: "BOH AAT" });
      let salesman = _.find(commission, { name: "Salesman AUTO2000" });
      let supervisor = _.find(commission, { name: "SS AUTO2000" });

      this.setState({
        sisaRuangNego: backFormatRupiah(sisaRuangNego.value),
        bonusKacab: backFormatRupiah(bonusKacab.value),
        bonusBOH: backFormatRupiah(bonusBOH.value),
        salesman: backFormatRupiah(salesman.value),
        supervisor: backFormatRupiah(supervisor.value),
        totalBenefitTiFinal: totalBenefit ? totalBenefit.price : 0,
        hargaFinal: 0,
      });
    } else {
      this.setState({
        sisaRuangNego: 0,
        bonusKacab: 0,
        bonusBOH: 0,
        salesman: 0,
        supervisor: 0,
        totalBenefitTiFinal: totalBenefit ? totalBenefit.price : 0,
        hargaFinal: 0,
      });
    }
  }

  calculationPrice(ruangNego, hargaPenawaran, hargaFinal) {
    let sisaRuangNego = ruangNego - (parseInt(hargaFinal) - hargaPenawaran);

    // (TT-1400) Sisa ruang nego tidak boleh lebih dari ruang nego
    if (sisaRuangNego > ruangNego) sisaRuangNego = ruangNego;

    const bonusKacab = (sisaRuangNego * 10) / 100;
    const bonusBOH = (sisaRuangNego * 5) / 100;
    const salesman = (sisaRuangNego * 20) / 100;
    const supervisor = (sisaRuangNego * 15) / 100;

    return { sisaRuangNego, bonusKacab, bonusBOH, salesman, supervisor };
  }

  render() {
    const {
      calculation,
      visibleModal,
      approvalType,
      tradeInStatus,
      sendToOdooStatus,
      isTrust,
    } = this.props;

    let disabled = false;
    let disabledConfirmOdoo = false;

    if (approvalType === "Trade In") {
      if (sendToOdooStatus) {
        disabled = true;
        disabledConfirmOdoo = true;
      } else {
        disabled = this.state.hargaFinal ? false : true;
      }
    }

    return (
      <Card title="Deal Section">
        {approvalType === "Trade In" && (
          <Row>
            <Col xs={24} md={12}>
              <Form.Item label="Harga Final" {...formItemLayout}>
                <InputNumber
                  disabled={disabledConfirmOdoo}
                  value={
                    this.state.hargaFinal
                      ? this.state.hargaFinal
                      : this.state.defaultFinalPriceApproval
                  }
                  formatter={value =>
                    `IDR ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }
                  parser={value => value.replace(/IDR\s?|(,*)/g, "")}
                  style={{ width: "100%" }}
                  onChange={v =>
                    isTrust
                      ? this.calculationNego(v, calculation)
                      : this.calculationMobbi(v, calculation)
                  }
                />
              </Form.Item>

              {isTrust && (
                <div>
                  <Form.Item label="Sisa Ruang Nego" {...formItemLayout}>
                    <InputNumber
                      disabled={true}
                      formatter={value =>
                        `IDR ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                      }
                      parser={value => value.replace(/IDR\s?|(,*)/g, "")}
                      style={{ width: "100%" }}
                      value={this.state.sisaRuangNego}
                    />
                  </Form.Item>

                  <Form.Item label="Bonus Salesman" {...formItemLayout}>
                    <InputNumber
                      disabled={true}
                      formatter={value =>
                        `IDR ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                      }
                      parser={value => value.replace(/IDR\s?|(,*)/g, "")}
                      style={{ width: "100%" }}
                      value={this.state.salesman}
                    />
                  </Form.Item>

                  <Form.Item label="Bonus Kacab" {...formItemLayout}>
                    <InputNumber
                      disabled={true}
                      formatter={value =>
                        `IDR ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                      }
                      parser={value => value.replace(/IDR\s?|(,*)/g, "")}
                      style={{ width: "100%" }}
                      value={this.state.bonusKacab}
                    />
                  </Form.Item>

                  <Form.Item label="Bonus BOH" {...formItemLayout}>
                    <InputNumber
                      disabled={true}
                      formatter={value =>
                        `IDR ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                      }
                      parser={value => value.replace(/IDR\s?|(,*)/g, "")}
                      style={{ width: "100%" }}
                      value={this.state.bonusBOH}
                    />
                  </Form.Item>

                  <Form.Item label="Bonus SS" {...formItemLayout}>
                    <InputNumber
                      disabled={true}
                      formatter={value =>
                        `IDR ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                      }
                      parser={value => value.replace(/IDR\s?|(,*)/g, "")}
                      style={{ width: "100%" }}
                      value={this.state.supervisor}
                    />
                  </Form.Item>
                </div>
              )}

              <Form.Item label="Total Benefit TI (Final)" {...formItemLayout}>
                <InputNumber
                  disabled={true}
                  formatter={value =>
                    `IDR ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }
                  parser={value => value.replace(/IDR\s?|(,*)/g, "")}
                  style={{ width: "100%" }}
                  value={this.state.totalBenefitTiFinal}
                />
              </Form.Item>
            </Col>
          </Row>
        )}
        <Row style={{ float: "right" }}>
          <Col span={24}>
            <Button
              disabled={disabledConfirmOdoo}
              type="danger"
              style={{ marginRight: 10 }}
              onClick={() => visibleModal("No Deal", true)}>
              NO DEAL
            </Button>

            <Button
              disabled={disabled}
              style={{ marginRight: 10 }}
              type="primary"
              onClick={() => visibleModal("Deal", true)}>
              DEAL
            </Button>

            {approvalType === "Trade In" && tradeInStatus === "Deal" && (
              <Button
                disabled={disabledConfirmOdoo}
                style={
                  disabledConfirmOdoo
                    ? { marginRight: 10 }
                    : {
                        marginRight: 10,
                        backgroundColor: "#52c41a",
                        color: "white",
                      }
                }
                onClick={() => visibleModal("Confirm", true)}>
                CONFIRM
              </Button>
            )}
          </Col>
        </Row>
      </Card>
    );
  }
}

export default DealSection;



// WEBPACK FOOTER //
// src/components/Dashboard/Approval/Component/Section/DealSection.js